import { Page } from "@shopify/polaris";
import { SetupChecklist } from "./components/SetupChecklist";

export function AdminGettingStartedRoute() {
  return (
    <Page
      title="Welcome to Smartrr!"
      subtitle="Let's get you set up. Follow the steps below to start your subscription program."
    >
      <SetupChecklist />
    </Page>
  );
}
